export default __webpack_public_path__ + "static/media/error-icon.79007db5.svg";